import { svg } from "config/svgStyles";

export const horizontalScrollViewContainer = () => ({
  px: "0",
  position: "relative",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flexGrow: 1,
  flexShrink: 1,
});

export const horizontalScrollView = ({
  height,
  justifyContent = "center",
}) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent,
  overflow: "hidden",
  height,
  flexGrow: 1,
  flexShrink: 1,
});

export const itemsContainer = {
  overflow: "auto",
  overflowX: "auto",
  overflowY: "hidden",
  pb: "200px", // to hide the scrollbar from view
};

export const items = ({
  itemGap,
  height,
  sideGutter = 0,
  sideButtonWidth = 0,
}) => {
  return {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    height,
    width: "max-content",
    gap: itemGap,

    px: `${sideGutter + sideButtonWidth}px`,
  };
};

export const buttonContainer = ({ shouldShowSideButtons, side }) => ({
  flexGrow: 0,
  flexShrink: 0,
  opacity: shouldShowSideButtons ? 1 : 0,
  pointerEvents: !shouldShowSideButtons ? "none" : "unset",
  transition: "opacity 0.2s ease-out",
  position: "absolute",
  [side]: 0,
  zIndex: 10,
});

export const leftButton =
  ({ UIVersion }) =>
  ({ isMobile }) => ({
    width: isMobile && UIVersion === 2 ? "40px" : "60px",
    height: isMobile && UIVersion === 2 ? "60px" : "100px",
    background: "text",
    color: "background",
    borderRadius: "0 20px 20px 0",
    zIndex: 2,

    "&[disabled], &:disabled": {
      background: "grey9",
      borderColor: "grey9",
      color: "grey7",
      cursor: "not-allowed",
      ...svg("grey7"),
    },
  });

export const rightButton =
  ({ UIVersion }) =>
  ({ isMobile }) => ({
    width: isMobile && UIVersion === 2 ? "40px" : "60px",
    height: isMobile && UIVersion === 2 ? "60px" : "100px",
    background: "text",
    color: "background",
    borderRadius: "20px 0 0 20px",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&[disabled], &:disabled": {
      background: "grey9",
      borderColor: "grey9",
      color: "grey7",
      cursor: "not-allowed",
      ...svg("grey7"),
    },
  });

export const arrowIcons =
  ({ UIVersion }) =>
  ({ isMobile }) => ({
    ...svg("white"),
    zIndex: 3,
    width: isMobile && UIVersion === 2 ? "16px" : "24px",
    height: isMobile && UIVersion === 2 ? "16px" : "24px",
  });
